import Message from './Message'
import ErrorMessage from './ErrorMessage'

export default Message
export { ErrorMessage }
